import * as React from 'react';
import { TextField } from '@material-ui/core';

interface Props {
  fullWidth?: boolean,
  id?: string,
  value?: string,
  label?: string,
  multiline?: boolean,
  onFinished: (value: string) => void,
  className?: string;
}

interface State {
  value: string
}

const WAIT_INTERVAL = 1000;

class OnFinishedTextField extends React.Component<Props, State> {
  public state = {
    value: ''
  };

  private timer: any = undefined;

  constructor(props: Props) {
    super(props)
  }

  public componentDidMount() {
    if (this.props.value !== undefined) {
      this.setState({value: this.props.value})
    }
  }

  public render() {
    return (
      <TextField
        className={this.props.className}
        fullWidth={true}
        id={'onFinish' + this.props.id}
        value={this.state.value}
        label={this.props.label}
        onChange={this.handleChange}
        multiline={this.props.multiline}/>
    )
  }

  private handleChange = (e: any) => {
    clearTimeout(this.timer);

    this.setState({value: e.target.value});

    this.timer = setTimeout(this.triggerChange, WAIT_INTERVAL)
  };

  private triggerChange = () => {
    const {value} = this.state;

    this.props.onFinished(value);
  }
}

export default OnFinishedTextField
